import(/* webpackMode: "eager", webpackExports: ["CategoriesLayout"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/CategoriesLayout/CategoriesLayout.tsx");
